"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewCycleResourceLog", {
    enumerable: true,
    get: function() {
        return ReviewCycleResourceLog;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _fields = require("../../fields");
const _reviewworkflow = require("../../review-workflow");
const _reviewreport = require("../../reviews/review-report");
const _baseresourcelog = require("../base-resource-log");
const ReviewCycleChangeType = _zod.z.union([
    _zod.z.literal("close"),
    _zod.z.literal("add-subject"),
    _zod.z.literal("remove-subject"),
    _zod.z.literal("automated-add-subject")
]);
const AutomatedAddSubjectCriteria = _zod.z.object({
    field: _zod.z.literal("is_manager").or(_zod.z.instanceof(_bson.ObjectId)),
    field_name: _zod.z.string(),
    field_value: _fields.FieldValueModel,
    value_name: _zod.z.string().or(_zod.z.string().or(_zod.z.undefined()).array()).optional()
}).array();
const ReviewCycleAddSubjectData = _zod.z.object({
    subject_id: _zod.z.string(),
    review_id: _zod.z.string(),
    review_reports: _zod.z.array(_reviewreport.ReviewReportModel),
    review_report_forms: _zod.z.array(_reviewworkflow.ReviewWorkflowFormModel),
    criteria: _zod.z.string().or(AutomatedAddSubjectCriteria).optional()
});
const ReviewCycleResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resource_type: _zod.z.literal("review-cycle"),
    change_type: _baseresourcelog.BaseResourceChangeType.or(ReviewCycleChangeType),
    data: ReviewCycleAddSubjectData
});
